import React, { useEffect } from 'react';
import { InputField } from '../../../../utility/form/';
import useContactUs from './useContactUs';
import { useTranslation } from 'react-i18next';
import LoadingButton from '../../../../utility/button/LoadingButton';
import Testimonial from '../Testimonials/Testimonial';
import { contactBg } from '../../../../../images';
import { getBrandName } from '../../Components/getBrandName';
import SEO from '../../../../SEO/Seo';
import { metaContent } from '../../../../SEO/metaContent';

const ContactSection = () => {
  const { t } = useTranslation();
  const { mail, phone, address } = getBrandName();
  const {
    form,
    onChange,
    onSubmit,
    loading,
    errors,
  } = useContactUs();

  useEffect(() => {
    // ✅ Select the static container
    const staticContainer = document.querySelector(".static-container");
    if (!staticContainer) return; // safeguard if not found

    // 🟢 Save old background before changing
    const oldBackground = staticContainer.style.backgroundImage;
    const oldBgColor = staticContainer.style.backgroundColor;
    const oldBgSize = staticContainer.style.backgroundSize;
    const oldBgRepeat = staticContainer.style.backgroundRepeat;
    const oldBgPosition = staticContainer.style.backgroundPosition;
    const oldBgAttachment = staticContainer.style.backgroundAttachment;

    // 🟣 Apply About Us background image
    staticContainer.style.backgroundImage = `url(${contactBg})`;
    staticContainer.style.backgroundSize = "cover";
    staticContainer.style.backgroundRepeat = "no-repeat";
    staticContainer.style.backgroundPosition = "center";
    // staticContainer.style.backgroundAttachment = "fixed";
    staticContainer.style.transition = "background 0.5s ease-in-out";

    // 🔴 Cleanup: restore old background when leaving AboutUs
    return () => {
      staticContainer.style.backgroundImage = oldBackground;
      staticContainer.style.backgroundColor = oldBgColor;
      staticContainer.style.backgroundSize = oldBgSize;
      staticContainer.style.backgroundRepeat = oldBgRepeat;
      staticContainer.style.backgroundPosition = oldBgPosition;
      staticContainer.style.backgroundAttachment = oldBgAttachment;
    };
  }, []);

  return (
    <>
      {/* Meta tags  */}
      <SEO {...metaContent.contact} />

      <section className="contact-section">
        <div className="contact-container">
          {/* Header */}
          <div className="contact-header">
            <div>
              <span className='contact-heading'>Let’s Close the Gap Between</span> <br />
              <span className='contact-heading-below'>Data and Clarity.</span>
            </div>
            <p className="contact-subtitle">
              Have a question, need a demo, or just want to explore how
              <br /> Gapalzye can simplify your Amazon analytics?
              <br />
              We’d love to hear from you.
            </p>
          </div>

          {/* Content */}
          <div className="contact-content">
            {/* Left Side - Info */}
            <div className="contact-info">
              <h3>Get In Touch</h3>
              <p>
                Join thousands of sellers who trust us to power their marketplace
                business.
              </p>
              <address>
                <i className="bi bi-geo-alt"></i>{" "}{address}
              </address>
              <p className="contact-phone">
                <i className="bi bi-telephone"></i>
                <a className="text-decoration-none" href={`tel:${phone}`}>{" "}{phone}</a>
              </p>

              <p className="contact-email">
                <i className="bi bi-envelope"></i>
                <a className="text-decoration-none" href={`mailto:${mail}`}>{" "}{mail}</a>
              </p>
            </div>
            {/* Right Side - Form */}
            <form className="contact-form" onSubmit={onSubmit} noValidate>
              <label>
                Name <span className="text-danger">*</span>
              </label>
                <input type="text" name="name" value={form.name} onChange={onChange} placeholder="Enter your name" />
                {errors.name && <div className="invalid-feedback d-block">{errors.name}</div>}

              <label>
                Email <span className="text-danger">*</span>
              </label>
                <input type="email" name="email" value={form.email} onChange={onChange} placeholder="Enter your email" />
                {errors.email && <div className="invalid-feedback d-block">{errors.email}</div>}
              <label>
                Subject <span className="text-danger">*</span>
              </label>
                <input type="text" name="subject" value={form.subject} onChange={onChange} placeholder="Enter your subject" />
                {errors.subject && <div className="invalid-feedback d-block">{errors.subject}</div>}
              <label>
                Message <span className="text-danger">*</span>
              </label>
                <textarea value={form.message} name="message" placeholder="Enter your message" onChange={onChange} />
                {errors.message && <div className="invalid-feedback d-block">{errors.message}</div>}
              <button type="submit">Send</button>
            </form>
          </div>
        </div>
      </section>
      <Testimonial />
    </>
  
  );
};

export default ContactSection;
